import { useEffect } from "react";

export default function RedirectPage() {
  useEffect(() => {
    const url = new URL(window.location.href);

    const merchantId = url.searchParams.get("merchant_id");
    const employeeId = url.searchParams.get("employee_id");
    const clientId = url.searchParams.get("client_id");

    // Extract access_token (usually comes after #)
    const hashParams = new URLSearchParams(window.location.hash.replace("#", ""));
    const accessToken = hashParams.get("access_token");

    async function redirectWithBusinessName() {
      if (!merchantId || !accessToken) {
        console.error("Missing merchant ID or access token.");
        return;
      }

      try {
        // Fetch merchant info from Clover API
        const response = await fetch(
          `https://sandbox.dev.clover.com/v3/merchants/${merchantId}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Clover API Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        // console.log("Merchant Data:", data);
        // console.log("Address Link:", data.address);

        // Merchant basic info
        const businessName = encodeURIComponent(data.name || "Unknown Business");

        // Default address values
        let address = "Unknown Street";
        let city = "Unknown City";
        let zipCode = "Unknown Postal";
        let phoneNumber = "Unknown phone number";


        // Fetch address details if link exists
        if (data.address?.href) {
          const addressResponse = await fetch(data.address.href, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          if (addressResponse.ok) {
            const addressData = await addressResponse.json();
            const { address1, city: cityName, zip, phoneNumber: phone } = addressData;
            
            address = encodeURIComponent(address1 || "");
            city = encodeURIComponent(cityName || "");
            phoneNumber = encodeURIComponent(phone || "Unknown phone number");

            zipCode = encodeURIComponent(zip || "");
          }
        }
        // Build the redirect URL
        const redirectUrl = `https://billing.clovermevweb.ca/subscribe/c4f94fb7ca6f3691ed37c5025d5fdf986a2bba0f6b053217ec6a82f3d2da95da/CLOVERWEB?cf_clover_merchant_id=${merchantId}&company_name=${businessName}&phone=${phoneNumber}&billing_city=${city}&billing_street=${address}&billing_zip=${zipCode}`;


        // Redirect
        window.location.href = redirectUrl;
      } catch (error) { 
        console.error("Failed to fetch merchant info:", error);
      }
    } 

    redirectWithBusinessName();
  }, []);

  return <p>Redirection en cours...</p>;
}
